import { useCallback, useEffect } from 'react';

import { useAuth } from '@contexts/auth';

import RedirectManager from './manager';

export function callRedirect(): void {
  const ref = RedirectManager.getDefault();

  if (ref) {
    ref.redirect();
  }
}

export const Redirect = () => {
  const { onLogout } = useAuth();
  const redirect = useCallback(() => {
    onLogout();
  }, [onLogout]);

  useEffect(() => {
    RedirectManager.register({ redirect });
  }, [redirect]);

  return null;
};
